import { ApiPlugin } from '@/plugins';

export default class GeolocationService {
  /**
   *
   * @param {sring} name
   * Could be a city name or a postal code
   */
  static async getLocationByName(name) {
    try {
      const response = await ApiPlugin.get(`/api/location-complete?loc=${name}`);
      return response.data?.locations || [];
    } catch (e) {
      console.error('Error fetching locations \n', e);
      return [];
    }
  }
}
